import authService, { AuthorizeService } from './AuthorizeService';

/**
 * Hook to return the authentication service.
 */
export function useAuthorizeService(): AuthorizeService {
    return authService;
}
